import React, { useState } from "react";
import { Box, Button, TextInput, Heading, Layer, Text, Select } from "grommet";
import { Add } from "grommet-icons";
import { useFetchRoomTypes } from "./redux/hooks";
import { useTranslation } from "react-i18next";

export default function AddDoor(props) {
  const { t } = useTranslation();
  const { type, onSubmit } = props;
  const [newDoors, setNewDoors] = useState("");
  const [open, setOpen] = useState();
  const [roomType, setRoomType] = useState(0);
  const { roomTypes } = useFetchRoomTypes();

  const onOpen = () => {
    setNewDoors("");
    setOpen(true);
  };
  const onClose = () => setOpen(undefined);

  function handleInputChange({ target: { name, value } }) {
    setNewDoors(value);
  }
  const handleAdd = () => {
    var doors = newDoors.split(",").map((str) => {
      const name = str.trim().split("|")[0];
      const pmsId = str.trim().split("|")[1];
      return {
        name,
        type,
        roomType,
        pmsId,
      };
    });
    onClose();
    onSubmit(doors);
  };

  return (
    <div>
      <Button
        primary
        icon={<Add size="small" />}
        size="small"
        label={t("common.add")}
        onClick={onOpen}
      />
      {open && (
        <Layer position="center" onClickOutside={onClose} onEsc={onClose}>
          <Box pad="medium" gap="small" width="medium">
            <Heading level={3} margin="none">
              {t("doorsDialog.addTitle", { type })}
            </Heading>
            <Text>
              {t("doorsDialog.addInstructions", { type })}
            </Text>
            <TextInput value={newDoors} onChange={handleInputChange} />
            {type === "room" && (
              <Select
                name="roomType"
                placeholder={t("doorsDialog.selectRoomType")}
                value={roomType}
                labelKey="name"
                valueKey={{ key: "_id", reduce: true }}
                options={roomTypes}
                onChange={({ value: nextValue }) => setRoomType(nextValue)}
              />
            )}
            <Box
              as="footer"
              gap="small"
              direction="row"
              align="center"
              justify="end"
              pad={{ top: "medium", bottom: "small" }}
            >
              <Button label={t("common.cancel")} onClick={onClose} color="dark-3" />
              <Button
                label={t("common.add")}
                onClick={handleAdd}
                primary
                color="status-ok"
              />
            </Box>
          </Box>
        </Layer>
      )}
    </div>
  );
}

AddDoor.propTypes = {};
AddDoor.defaultProps = {};
